import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BranchTableViewModel } from '../../shared/models/autogenerated-piping';

// Interface para el resultado de validación de Branch Table
export interface BranchTableValidationResult {
  isCurrent: boolean;
  latestVersion?: BranchTableViewModel;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BranchTableSyncService {
  private baseUrl = environment.pipingApiEndpoint;

  constructor(private http: HttpClient) {}

  /**
   * Valida si una Branch Table es la más reciente y devuelve la última versión si no lo es
   * @param branchTableId ID de la tabla a validar
   */
  validateAndGetLatestBranchTable(branchTableId: string): Observable<BranchTableValidationResult> {
    const url = `${this.baseUrl}/BranchTable/ValidateAndGetLatest/${branchTableId}`;
    return this.http.get<BranchTableValidationResult>(url);
  }
}
